interface FlagProps {
  className?: string;
}

export function FlagFR({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#002654" d="M0 0h213.3v480H0z"/>
      <path fill="#fff" d="M213.3 0h213.4v480H213.3z"/>
      <path fill="#ce1126" d="M426.7 0H640v480H426.7z"/>
    </svg>
  );
}

export function FlagEN({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#012169" d="M0 0h640v480H0z"/>
      <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"/>
      <path fill="#C8102E" d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"/>
      <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z"/>
      <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z"/>
    </svg>
  );
}

export function FlagDE({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#000" d="M0 0h640v160H0z"/>
      <path fill="#D00" d="M0 160h640v160H0z"/>
      <path fill="#FFCE00" d="M0 320h640v160H0z"/>
    </svg>
  );
}

export function FlagES({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#AA151B" d="M0 0h640v480H0z"/>
      <path fill="#F1BF00" d="M0 120h640v240H0z"/>
    </svg>
  );
}

export function FlagIT({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#009246" d="M0 0h213.3v480H0z"/>
      <path fill="#fff" d="M213.3 0h213.4v480H213.3z"/>
      <path fill="#ce2b37" d="M426.7 0H640v480H426.7z"/>
    </svg>
  );
}

export function FlagAR({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#006C35" d="M0 0h640v480H0z"/>
      <path fill="#fff" d="M0 0h640v160H0z"/>
      <path fill="#000" d="M0 320h640v160H0z"/>
    </svg>
  );
}

export function FlagNL({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#21468B" d="M0 0h640v480H0z"/>
      <path fill="#fff" d="M0 0h640v320H0z"/>
      <path fill="#AE1C28" d="M0 0h640v160H0z"/>
    </svg>
  );
}

export function FlagPT({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#006600" d="M0 0h640v480H0z"/>
      <path fill="#FF0000" d="M256 0h384v480H256z"/>
      <circle cx="256" cy="240" r="80" fill="#FFCC00"/>
      <circle cx="256" cy="240" r="60" fill="#FF0000"/>
      <path fill="#fff" d="M224 200h64v80h-64z"/>
    </svg>
  );
}

export function FlagJA({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#fff" d="M0 0h640v480H0z"/>
      <circle cx="320" cy="240" r="120" fill="#bc002d"/>
    </svg>
  );
}

export function FlagZH({ className = "w-5 h-4" }: FlagProps) {
  return (
    <svg className={className} viewBox="0 0 640 480" xmlns="http://www.w3.org/2000/svg">
      <path fill="#de2910" d="M0 0h640v480H0z"/>
      <path fill="#ffde00" d="M96 64l24 72-60-44h72l-60 44z"/>
      <path fill="#ffde00" d="M176 32l8 24-20-14h24l-20 14z"/>
      <path fill="#ffde00" d="M208 64l8 24-20-14h24l-20 14z"/>
      <path fill="#ffde00" d="M208 112l8 24-20-14h24l-20 14z"/>
      <path fill="#ffde00" d="M176 144l8 24-20-14h24l-20 14z"/>
    </svg>
  );
}

export const flags = {
  fr: FlagFR,
  en: FlagEN,
  de: FlagDE,
  es: FlagES,
  it: FlagIT,
  ar: FlagAR,
  nl: FlagNL,
  pt: FlagPT,
  ja: FlagJA,
  zh: FlagZH,
} as const;
